import { Component, Input } from '@angular/core';
import { StripePaymentMethodModel } from '../../../../../../../common/dist/angular/models/stripe-payment-method.model';

@Component({
  selector: 'app-credit-card-row',
  templateUrl: './credit-card-row.component.html',
  styleUrls: ['./credit-card-row.component.scss'],
  standalone: false,
})
export class CreditCardRowComponent {
  @Input()
  public paymentMethod: StripePaymentMethodModel;
}
